import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the UpdatecontacteditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-updatecontactedit',
  templateUrl: 'updatecontactedit.html',
})
export class UpdatecontacteditPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad UpdatecontacteditPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/updatecontactedit/updatecontactedit.ts